import { render, staticRenderFns } from "./EduTeacher.vue?vue&type=template&id=29a76868&scoped=true"
import script from "./EduTeacher.vue?vue&type=script&lang=js"
export * from "./EduTeacher.vue?vue&type=script&lang=js"
import style0 from "./EduTeacher.vue?vue&type=style&index=0&id=29a76868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a76868",
  null
  
)

export default component.exports